import { render, staticRenderFns } from "./serveTab4.vue?vue&type=template&id=1ed60fb0&scoped=true"
import script from "./serveTab4.vue?vue&type=script&lang=js"
export * from "./serveTab4.vue?vue&type=script&lang=js"
import style0 from "./serveTab4.vue?vue&type=style&index=0&id=1ed60fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed60fb0",
  null
  
)

export default component.exports